import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-ui-resize-handle',
  
  imports: [],
  templateUrl: './ui-resize-handle.component.html',
  styleUrl: './ui-resize-handle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiResizeHandleComponent {

}
